import onetime from "@-/com.npmjs.onetime";
import { ERHUA_CHARACTERS } from "#erhua-characters";

import erhuaWordsData from "#erhua-words.gen.json" with { type: "json" };

const getErhuaWordSet = onetime((): ReadonlySet<string> => new Set(erhuaWordsData));

/**
 * Whether the character at `characterIndex` of `word` is an erhua 儿/兒: read as an `r` on the
 * syllable before it (一点儿 yìdiǎnr) rather than as a syllable of its own (女儿 nǚ'ér, 儿子 érzi).
 *
 * The word list is precomputed from the dictionary into `erhua-words.gen.json`, so this never
 * waits on a database read. A listed word reads every 儿/兒 after its first character as erhua.
 */
export function isErhuaCharacter({
  character,
  characterIndex,
  word,
}: {
  character: string;
  characterIndex: number;
  word: string;
}): boolean {
  return characterIndex > 0 && ERHUA_CHARACTERS.has(character) && getErhuaWordSet().has(word);
}
